import { forEach, map } from "lodash"
import { buildContributorKey } from "helpers/contributors"
import { getContributorLabel, NOT_HELD } from "../../../connected-components/asset-view/helpers"

export function createContributorEntry(contributor, prefix, values, children = null) {
  return {
    label: getContributorLabel(contributor),
    notHeld: contributor.notHeld,
    // Currently this will always be undefined since these helper functions are for risk and marginal contributors, not performance contributors or composition
    isUnmodeled: contributor.isUnmodeled,
    values: {
      [prefix]: values,
    },
    ...(children && { children }),
  }
}

export function processNotHeldContributor(acc, contributor, prefix, options, getValues) {
  if (!acc[NOT_HELD]) {
    acc[NOT_HELD] = {
      label: "Not Held",
      notHeld: true,
      values: {
        [prefix]: {},
      },
    }
  }

  const values = getValues(contributor, options)
  forEach(values, (value, key) => {
    acc[NOT_HELD].values[prefix][key] = (acc[NOT_HELD].values[prefix][key] ?? 0) + value
  })
}

export function processRegularContributor(acc, contributor, prefix, options, getValues, sumNestedContributors) {
  const children = contributor.contributors
    && recursiveParseContributors(prefix, contributor.contributors, { ...options, parent: contributor }, getValues, sumNestedContributors)

  const values = !contributor.contributors ? getValues(contributor, options)
    : map(children, child => child.values[prefix]).reduce(sumNestedContributors, {})

  acc[buildContributorKey(contributor)] = createContributorEntry(contributor, prefix, values, children)
}

export function recursiveParseContributors(prefix, contributors, options, getValues, sumNestedContributors) {
  return contributors?.reduce((acc, contributor) => {
    if (contributor.notHeld && options.notHeldRollup) {
      processNotHeldContributor(acc, contributor, prefix, options, getValues)
    } else {
      processRegularContributor(acc, contributor, prefix, options, getValues, sumNestedContributors)
    }
    return acc
  }, {})
}
